import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Link, Properties } from './properties.model';

@Injectable()
export class PropertiesService {
    private propertiesUrl = 'api/properties';

    public properties: Properties;
    public headerLinks: Link[];
    public footerLinks: Link[];

    constructor(private http: Http) { }

    loadProperties(): Promise<Properties> {
        return this.http.get(this.propertiesUrl).toPromise().then(res => {
            return this.properties = res.json();
        });
    }
    loadHeaderLinks(): Promise<Link[]> {
        return this.http.get('api/header-links').toPromise().then(res => {
            return this.headerLinks = res.json();
        });
    }
    loadFooterLinks(): Promise<Link[]> {
        return this.http.get('api/footer-links').toPromise().then(res => {
            return this.footerLinks = res.json();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/properties.service.ts